import { registerComponent } from '@gig/magic-common';
import RadioComponent from './radio.vue.js';

var Radio = registerComponent(RadioComponent);

export { Radio };
